import { jsxs } from 'react/jsx-runtime';
import classNames from '../../../node_modules/.pnpm/classnames@2.5.1/node_modules/classnames/index.js';
import style from './Avatar.module.css.js';

const Avatar = ({ text, children, className, size = "normal" }) => {
    const initial = text && String.fromCodePoint(text.codePointAt(0) ?? 0).toUpperCase();
    return (jsxs("div", { className: classNames(style.avatar, style[size], className), children: [initial, children] }));
};

export { Avatar };
//# sourceMappingURL=Avatar.js.map
